import Cookies from "js-cookie";
import { createContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Navigate } from "react-router-dom";
import { Button, Modal } from "rsuite";
import { getUserProfile } from "../utils/helper";

const AuthContext = createContext(null);

const timeout = 1800_000; // 1800 seconds = 30 minutes
const promptBeforeIdle = 60_000; // 60 seconds = 1 minute

export const AuthProvider = ({ children }) => {
  const [remaining, setRemaining] = useState(timeout);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const onIdle = () => {
    localStorage.removeItem("LI_PROFILE");
    Cookies.remove("LIFE_ACCESS_TOKEN");
    return <Navigate to="/login" replace={true} />;
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  if (!getUserProfile()) {
    localStorage.removeItem("LI_PROFILE");
    Cookies.remove("LIFE_ACCESS_TOKEN");
    return <Navigate to="/login" replace={true} />;
  }

  const handleStillHere = () => {
    activate();
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>Idle detected!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Are you still here?</h3>
          <p>Logging out in {remaining} seconds</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleStillHere}
            appearance="primary"
            className="btn-primary"
          >
            Im still here
          </Button>
        </Modal.Footer>
      </Modal>

      <AuthContext.Provider>{children}</AuthContext.Provider>
    </div>
  );
};

export const Logout = () => {
  localStorage.removeItem("LI_PROFILE");
  Cookies.remove("LIFE_ACCESS_TOKEN");
  return window.location.replace("/");

  // <Navigate to="/" replace={true} />;
  // return window.location.reload();
};
